import { carouselItems } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20illustration%20with%20warm%20orange%20and%20red%20energy%20effects%2C%20powerful%20character%20silhouette%20in%20combat%20pose%2C%20speed%20lines%20and%20impact%20bursts%2C%20dramatic%20lighting%20with%20golden%20highlights%2C%20dark%20gradient%20background%20with%20fiery%20accents%2C%20epic%20cinematic%20composition&width=1200&height=600&seq=carousel-bg-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Soft%20romantic%20anime%20illustration%20with%20cherry%20blossom%20petals%20floating%2C%20warm%20pink%20and%20peach%20color%20palette%2C%20gentle%20sunlight%20filtering%20through%20trees%2C%20dreamy%20atmosphere%20with%20lens%20flare%2C%20clean%20pastel%20gradient%20background%2C%20emotional%20and%20tender%20mood&width=1200&height=600&seq=carousel-bg-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Majestic%20oriental%20fantasy%20landscape%20with%20floating%20mountains%20and%20ancient%20temples%2C%20warm%20golden%20and%20jade%20green%20color%20scheme%2C%20misty%20clouds%20and%20glowing%20auroras%2C%20epic%20scale%20with%20dramatic%20perspective%2C%20Chinese%20ink%20painting%20inspired%20aesthetic&width=1200&height=600&seq=carousel-bg-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20treasure%20discovery%20themed%20illustration%20with%20glowing%20mysterious%20light%2C%20warm%20amber%20and%20teal%20color%20contrast%2C%20hidden%20gem%20visual%20metaphor%2C%20sparkling%20particles%20and%20magical%20atmosphere%2C%20clean%20dark%20background%20with%20radiant%20center%2C%20elegant%20composition&width=1200&height=600&seq=carousel-bg-4&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-1 text-sm text-foreground-500">精心策划的漫画专题合集，发现你的下一部最爱</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden h-64 md:h-72 lg:h-80 cursor-pointer"
            >
              <img
                src={carouselImages[item.id - 1]}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block text-[11px] px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 font-medium backdrop-blur-sm mb-2">{item.tag}</span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-background-50">{item.title}</h3>
                <p className="text-sm text-background-50/80 mt-1">{item.subtitle}</p>
                <p className="text-xs text-background-50/60 mt-2 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}